import { render, staticRenderFns } from "./LiveCode.vue?vue&type=template&id=48023713&scoped=true&"
import script from "./LiveCode.vue?vue&type=script&lang=js&"
export * from "./LiveCode.vue?vue&type=script&lang=js&"
import style0 from "./LiveCode.vue?vue&type=style&index=0&id=48023713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48023713",
  null
  
)

export default component.exports